import React, { Fragment } from 'react';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import BaseForm from '../../../../components/form/BaseForm';
import Input from '../../../../components/input/Input';
import TextArea from '../../../../components/input/TextArea';
import Select from '../../../../components/input/Select';
import SearchBox from '../../../../components/outline/SearchBox';
import { setClearDash, setIfNull, setTrim } from '../../../../lib/common';
import { ACCOUNT_USER_STATUS_SELECT_LIST } from '../../../../constants/service/app/accountUserConstants';
import {
  MAXIMUM_NUMBER_OF_SEARCH_BOX_INPUT_TEXT,
  MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID,
  POINT_GENERATE_SEARCH_BOX_SELECT_LIST,
} from '../../../../constants/service/app/pointConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { POINT_GENERATE_USER_SEARCH_OPTION_MODEL } from '../../../../store/modules/point/models';
import './PointGenerateSearchBox.scss';

const PointGenerateSearchBox = (props) => {
  const { setData, getList, searchData } = props;
  const { name, account, status, createDate, searchType } = searchData;

  return (
    <SearchBox
      className="point-generate-search-box"
      onSearch={() => {
        getList({
          searchOption: {
            name,
            account,
            status,
            createDate,
            searchType,
          },
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: POINT_GENERATE_USER_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: POINT_GENERATE_USER_SEARCH_OPTION_MODEL,
        });
      }}
    >
      <BaseForm
        label={
          <div className="inline-form">
            <Select
              list={POINT_GENERATE_SEARCH_BOX_SELECT_LIST}
              defaultValue={searchType.type}
              value={searchType.type}
              onChange={(value) => {
                setData({
                  path: ['searchType', 'type'],
                  value,
                });
              }}
            />
          </div>
        }
        content={
          <div className="inline-form">
            <TextArea
              value={searchType.value}
              maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID}
              onChange={(value) => {
                setData({
                  path: ['searchType', 'value'],
                  value: setIfNull(setTrim(setClearDash(value))),
                });
              }}
              onPressEnter={() =>
                getList({
                  searchOption: searchData,
                  pagination: _LIST_PAGINATION_MODEL,
                })
              }
            />
          </div>
        }
      />

      <BaseForm
        label="검색어"
        content={
          <Fragment>
            <div className="inline-form">
              <label>이름</label>
              <Input
                value={name}
                maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_INPUT_TEXT}
                onChange={(value) => {
                  setData({
                    path: ['name'],
                    value: setIfNull(setTrim(value)),
                  });
                }}
                onPressEnter={() =>
                  getList({
                    searchOption: searchData,
                    pagination: _LIST_PAGINATION_MODEL,
                  })
                }
              />
            </div>

            <div className="inline-form">
              <label>ID</label>
              <Input
                value={account}
                maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_INPUT_TEXT}
                onChange={(value) => {
                  setData({
                    path: ['account'],
                    value: setIfNull(setTrim(value)),
                  });
                }}
                onPressEnter={() =>
                  getList({
                    searchOption: searchData,
                    pagination: _LIST_PAGINATION_MODEL,
                  })
                }
              />
            </div>
          </Fragment>
        }
      />

      <BaseForm
        label="상태"
        content={
          <div className="inline-form">
            <Select
              list={ACCOUNT_USER_STATUS_SELECT_LIST}
              defaultValue={status}
              value={status}
              onChange={(value) => {
                setData({
                  path: ['status'],
                  value,
                });
              }}
            />
          </div>
        }
      />

      <BaseForm
        label="가입일자"
        content={
          <div className="quick-date-picker">
            <DateRangePicker
              value={createDate}
              format={DATE_FORMAT.YMD_DASH_FORMAT}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(value) =>
                setData({
                  path: ['createDate'],
                  value,
                })
              }
            />
          </div>
        }
      />
    </SearchBox>
  );
};

export default PointGenerateSearchBox;
